import React from "react";
import { TailwindModal } from "../../../components/TailwindModal";
import { Button, Typography } from "@mui/material";

interface ConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    confirmButtonColor?:
        | "primary"
        | "secondary"
        | "error"
        | "info"
        | "success"
        | "warning";
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmButtonColor = "error",
}) => {
    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <TailwindModal isOpen={isOpen} onClose={onClose}>
            <div className="w-full max-w-md mx-auto bg-white rounded-xl shadow-xl p-6">
                <div className="mb-6">
                    <Typography
                        variant="h6"
                        component="h3"
                        className="font-semibold mb-3 text-slate-900"
                    >
                        {title}
                    </Typography>
                    <Typography
                        variant="body2"
                        className="text-sm text-slate-600"
                    >
                        {message}
                    </Typography>
                </div>
                <div className="flex items-center justify-end gap-3 mt-6">
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        className="normal-case"
                    >
                        {cancelText}
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        variant="contained"
                        color={confirmButtonColor}
                        className="normal-case"
                    >
                        {confirmText}
                    </Button>
                </div>
            </div>
        </TailwindModal>
    );
};
